import { SourceType } from '@aloft/toolkit-shared';

export const FEATURE_GRID_DATA_SOURCES: SourceType[] = ['abode_mls', 'abode_public_record'];

export const PROPERTY_GRID_COLUMN_WIDTH = '375px';
export const AIV_ARV_PROPERTY_GRID_COLUMN_WIDTH = '525px';
